export const additionalSounds = [
    {
        src: "sounds/roar.mp3",
        id: "roar",
    },
];
